import React from "react";
import "./style.css";

const ProgressCard = ({ title, color, solvedMcq, totalMcq }) => {
  return (
    <div className="progressCard">
      <span style={{ color: color }}>{title}</span>
      <span>
        {solvedMcq}/{totalMcq}
      </span>
    </div>
  );
};

export default ProgressCard;
